export default __webpack_public_path__ + "static/media/person-3.cfdca65e.png";